<template lang="pug">
.new-vendor-account(v-loading="loading")
  .vendor-account__header {{ isView ? $t('编辑项目') : $t('新建项目') }}
  el-form(
    ref="form"
    :model="form"
    :v-model="form"
    label-width="150px"
    :rules="rules"
  )
    el-form-item(
      :label="$t('姓名')"
      prop="campaign_name"
    )
      el-input(v-model="form.campaign_name")
    el-form-item(
      :label="$t('登录邮箱')"
      prop="campaign_name"
    )
      el-input(v-model="form.campaign_name")
    el-form-item(
      :label="$t('职位')"
      prop="campaign_name"
    )
      el-input(v-model="form.campaign_name")
    el-form-item(
      :label="$t('手机')"
      prop="campaign_name"
    )
      el-input(v-model="form.campaign_name")
    el-form-item(
      :label="$t('服务类别&品牌')"
      required
    )
      el-col(
        style="width: 200px"
      )
        el-form-item(
          prop="brandCategory"
        )
          el-select(
            :disabled="isView"
            v-model="form.brandCategory"
            :placeholder="$t('请选择品牌类别')",
            @change="onBrandCategoryChange"
          )
            el-option(
              v-for="o, i in brandCategorys"
              :key="i"
              :value="o.brand_category_id"
              :label="o.brand_category_name"
            )
      el-col(
        style="width: 200px; margin-left: 20px"
      )
        el-form-item(
          v-if="brands.length > 0"
          prop="brand"
        )
          el-select(
            :disabled="isView"
            v-model="form.brand"
            :placeholder="$t('请选择品牌')",
          )
            el-option(
              v-for="o, i in brands"
              :key="i"
              :value="o.brand_id"
              :label="o.brand_name"
            )
  footer-button(
    @confirm="onConfirm('form')"
    @cancel="cancel"
    :confirmButton="isView ? $t('保存') : $t('提交')"
  )
</template>

<script>
import axios from 'axios'
import { checkIsView, format4backend } from '@/umcc/util'
import FooterButton from '@/components/FooterButton'
import InputWithCommas from '@/components/InputWithCommas'
import AuditVersions from '@/components/AuditVersions'
import dayjs from 'dayjs'

export default {
  components: {
    FooterButton,
    InputWithCommas,
    AuditVersions
  },
  data () {
    let validateBudget = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('请输入预算')))
      }
      setTimeout(() => {
        if (value < 0) {
          callback(new Error(this.$t('预算不能为负数')))
        } else {
          callback()
        }
      }, 1000)
    }
    let validateIntro = (rule, value, callback) => {
      if (value.length > 500) {
        callback(new Error(this.$t('描述不多于500字')))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      brandCategorys: [],
      noIO: false,
      form: {
        campaign_name: '',
        brandCategory: 1,
        brand: '',
        is_bypass: 0,
        campaign_io: [''],
        budget: '',
        introduction: '',
        start_date: '',
        end_date: ''
      },
      contact: null,
      email: '',
      cc: '',
      visible: false,
      rules: {
        campaign_name: [
          { required: true, message: this.$t('请输入项目名称'), trigger: 'blur' }
        ],
        brandCategory: [
          { required: true }
        ],
        brand: [
          { required: true }
        ],
        campaign_io: [
          { required: true }
        ],
        start_date: [
          { required: true, message: this.$t('请输入上线开始日期'), trigger: 'change' }
        ],
        end_date: [
          { required: true, message: this.$t('请输入上线截止日期'), trigger: 'change' }
        ],
        budget: [
          { validator: validateBudget, trigger: 'blur', required: true }
        ],
        introduction: [
          {
            required: false, validator: validateIntro, trigger: 'blur'
          }
        ]
      },
      startDatePickerOptions: {
        disabledDate: (time) => {
          if (this.form.end_date) {
            return time.getTime() > dayjs(this.form.end_date).unix() * 1000
          }
        }
      },
      endDatePickerOptions: {
        disabledDate: (time) => {
          if (this.form.start_date) {
            return time.getTime() < dayjs(this.form.start_date).unix() * 1000
          }
        }
      }
    }
  },
  mounted () {
    this.getBrandTreeStructure()
    if (this.campaignId) {
      this.getCampaign()
    }
  },
  computed: {
    isView () {
      return checkIsView()
    },
    brands () {
      return this.brandCategorys.length !== 0 ? this.brandCategorys.find(b => b.brand_category_id === this.form.brandCategory).children : []
    },
    campaignId () {
      return this.$store.state.campaign.id
    },
    taskName () {
      return this.$store.state.campaign.taskName
    }
  },
  methods: {
    onBrandCategoryChange () {
      const firstBrand = this.brandCategorys.find(b => b.brand_category_id === this.form.brandCategory).children[0]
      if (firstBrand) {
        this.form.brand = firstBrand.brand_id
      }
    },
    getBrandTreeStructure () {
      axios
        .get('/common/getBrandTreeStructure')
        .then((res) => {
          this.brandCategorys = res
          if (this.campaignId == null) {
            this.form.brandCategory = res[0].brand_category_id
            this.form.brand = res[0].children[0].brand_id
          }
        })
    },
    changeNoIO () {
      if (this.noIO === true) {
        this.form.campaign_io = ['']
      }
    },
    submit () {
      if (!this.noIO && this.form.campaign_io.some(io => io === '')) {
        this.$message.error(this.$t('IO号不能为空'))
        return
      }

      if (!this.noIO && this.form.campaign_io.some(io => io.length > 100)) {
        this.$message.error(this.$t('IO号长度不能超过100字'))
        return
      }

      const regexp = /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/
      if (!this.noIO && this.form.campaign_io.some(io => !regexp.test(io))) {
        this.$message.error(this.$t('请输入正确的IO号'))
        return
      }

      const loading = this.$loading()
      const params = {
        campaign: {
          campaign_name: this.form.campaign_name,
          start_date: this.form.start_date,
          end_date: this.form.end_date
        }
      }

      let apiPath
      if (this.campaignId && this.isView) {
        apiPath = '/management/campaign/updateCampaignName'
        params.campaign.campaign_id = this.campaignId
      } else {
        if (!this.noIO) {
          params.campaign_io = this.form.campaign_io.map(io => {
            return {
              io: io
            }
          })
        }
        if (this.brands.length > 0) {
          params.campaign.brand_id = this.form.brand
        }
        apiPath = '/management/campaign/saveCampaign'
        if (this.campaignId) {
          params.campaign.campaign_id = this.campaignId
          params.status = 'open'
          params.task_id = this.$store.state.campaign.taskId
          apiPath = '/management/campaign/updateCampaign'
        }
        params.servlet_path = this.$route.path
        params.campaign.brand_category_id = this.form.brandCategory
        params.campaign.is_bypass = this.form.is_bypass
        params.campaign.is_campaign_io = this.noIO ? 0 : 1
        params.campaign.budget = Number(this.form.budget)
        params.campaign.introduction = this.form.introduction
        params.task_name = this.$store.state.campaign.taskName
      }
      axios
        .post(apiPath, format4backend(params))
        .then((res) => {
          if (!this.campaignId) {
            this.$message.success(this.$t('新建项目成功'))
            this.$store.commit('campaign/setId', res.campaign_id)
            this.$store.commit('campaign/setBusinessType', res.business_type)
            this.$store.commit('campaign/setOriginalBusinessType', res.business_type)
          }
          this.$store.commit('campaign/setCampaignName', this.form.campaign_name)
          this.$router.push('/campaign/process')
          loading.close()
        })
        .catch((err) => {
          loading.close()
          throw new Error(err)
        })
    },
    cancel () {
      if (this.campaignId) {
        this.$router.push('/campaign/process')
      } else {
        this.$router.push('/campaign/list')
      }
    },
    async onConfirm (formName) {
      if (this.isView) {
        const userCanEdit = await axios.get('/common/canEditCampaign', {
          params: {
            campaign_id: this.campaignId,
            task_name: this.taskName
          }
        })
        if (!userCanEdit.can_edit) {
          this.$message.error(this.$t('您无权限编辑当前页面'))
          return
        }
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submit()
        }
      })
    },
    getCampaign () {
      this.loading = true
      axios
        .get('/management/campaign/getCampaign', {
          params: {
            campaign_id: this.campaignId,
            is_final_scope: 0
          }
        })
        .then((res) => {
          this.form.campaign_name = res.campaign_name
          this.form.brandCategory = res.brand_category_id
          this.form.brand = res.brand_id
          this.form.campaign_io = res.campaign_io.length === 0 ? [''] : res.campaign_io.map((v) => v.io)
          this.form.budget = res.budget
          this.form.start_date = res.start_date
          this.form.end_date = res.end_date
          this.form.introduction = res.introduction
          this.noIO = res.is_campaign_io === 0
          this.loading = false
        })
    }
  }
}
</script>

<style lang="stylus">
.new-vendor-account
  .vendor-account__header
    font-size: 16px
    padding: 0 20px 20px
    font-weight: bold
  .el-form
    padding 0 20px
  .el-input
    width 200px
  .footer-button
    padding-top 20px
    padding-left 170px
</style>
